const mailIds =
    {
        saraswathi_id : "s.saraswathi",
        madhuri_gattu_id : "madhuri.gattu",
        lkm_oracle_team : "lkm_oracle_team",
        atci_lkm_sap : "ATCI_LKM_SAP",
        atci_lkm_ascend: "ATCI.SAP.ASCEND",
        atci_lkm_lis_portal_develoment : "ATCI.LKM.LIS.PORTALDEVELOPMENT",
    }
const domain = "accenture.com";

const saraswathi_mail = `${mailIds.saraswathi_id}@${domain}`
const madhuri_gattu_mail =`${mailIds.madhuri_gattu_id}@${domain}`
const lkm_oracle_team_mail =`${mailIds.lkm_oracle_team}@${domain}`
const atci_lkm_sap_mail =`${mailIds.atci_lkm_sap}@${domain}`
const atci_lkm_ascend_mail =`${mailIds.atci_lkm_ascend}@${domain}`
const atci_lkm_lis_portal_develoment_mail =`${mailIds.atci_lkm_lis_portal_develoment}@${domain}`
console.log(saraswathi_mail, madhuri_gattu_mail, lkm_oracle_team_mail, atci_lkm_ascend_mail,atci_lkm_lis_portal_develoment_mail, atci_lkm_sap_mail);

export { saraswathi_mail, madhuri_gattu_mail, lkm_oracle_team_mail, atci_lkm_ascend_mail,atci_lkm_lis_portal_develoment_mail, atci_lkm_sap_mail };